/* Original BlackPatel shell adapter. Cart contents and checkout stay in native Dawn. */
(() => {
  let cartObserver;
  let observedIcons;
  function initializeShell() {
    const footerNav = document.querySelector('.bp-shell-bottom-nav');
    const headerIcons = document.querySelector('.bp-shell-header .header__icons');
    if (!footerNav) return;
    const count = footerNav.querySelector('[data-bp-cart-count]');
    const cartLink = footerNav.querySelector('[data-bp-cart-open]');
    function synchronizeCartCount() {
      if (!count) return;
      const nativeCount = headerIcons?.querySelector('#cart-icon-bubble .cart-count-bubble');
      // Dawn repeats the count in a visually hidden label; read one span only.
      const countLabel = nativeCount?.querySelector('span[aria-hidden="true"]') || nativeCount?.querySelector('span');
      const value = countLabel?.textContent.match(/\d+/)?.[0] || '0';
      count.textContent = value;
      if (cartLink) cartLink.setAttribute('aria-label', `My cart, ${value} items`);
    }
    synchronizeCartCount();
    if (observedIcons !== headerIcons) {
      cartObserver?.disconnect();
      observedIcons = headerIcons;
      if (headerIcons) {
        cartObserver = new MutationObserver(synchronizeCartCount);
        cartObserver.observe(headerIcons, { childList: true, subtree: true, characterData: true });
      }
    }
  }
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const backLink = event.target.closest('.bp-shell-bottom-nav [data-bp-back]');
    if (backLink) {
      try {
        if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) {
          event.preventDefault();
          history.back();
        }
      } catch (_) { /* The normal collection link is the fallback. */ }
      return;
    }
    const opener = event.target.closest('.bp-shell-bottom-nav [data-bp-cart-open]');
    const drawer = opener && document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      event.preventDefault();
      drawer.open(opener);
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeShell, { once: true });
  else initializeShell();
  document.addEventListener('shopify:section:load', () => {
    // A rebuilt section can replace either end of the counter connection.
    cartObserver?.disconnect();
    observedIcons = null;
    initializeShell();
  });
})();
